import { useIntl } from 'react-intl'
import { Link, useParams } from 'react-router-dom'
import QueryString from 'qs'

import HistoryList from './HistoryList'
import { useGetPartnerHistory } from '../../../hooks/useGetPartnerHistory'
import { useHistoryItemRenderer } from './useHistoryItemRenderer'

const PartnerHistory = ({ partner }: any) => {
   const intl = useIntl()
   const { id, accountCode } = useParams()
   const { data, status } = useGetPartnerHistory({ memberId: id, size: 10, page: 0 })
   const { renderItem } = useHistoryItemRenderer({ showChanges: true })

   const renderFooter = () => (
      <div className="p-4 border-t">
         <Link
            className="text-blue-500"
            to={`/${accountCode}/operations?${QueryString.stringify({ query: partner?.email }, { encode: true })}`}
         >
            {intl.formatMessage({ id: 'partner.all.operations' })}
         </Link>
      </div>
   )

   return (
      <HistoryList
         title={intl.formatMessage({ id: 'partner.history' })}
         items={data?.items || []}
         isLoading={status === 'pending'}
         emptyText={intl.formatMessage({ id: 'partner.history.empty' })}
         renderItem={renderItem}
         renderFooter={renderFooter}
      />
   )
}

export default PartnerHistory
